/* Klaviyo Newsletter */
document.addEventListener('DOMContentLoaded', function() {
  const klaviyoContainers = document.querySelectorAll('.klaviyo-newsletter--container');

  for(const klaviyoContainer of klaviyoContainers) {
    const input = klaviyoContainer.querySelector('.input');
    const button = klaviyoContainer.querySelector('button');
    const listId = klaviyoContainer.dataset.listId;

    if(input && button && listId) {
      button.addEventListener('click', function() {
        const bodyData = {
          "data": {
            "type": "subscription",
            "attributes": {
              "profile": {
                "data": {
                  "type": "profile",
                  "attributes": {
                    "email": input.value
                  }
                }
              }
            },
            "relationships": {
              "list": {
                "data": {
                  "type": "list",
                  "id": listId
                }
              }
            }
          }
        };
        const currentDate = new Date();
        const formatter = new Intl.DateTimeFormat('en-CA', { year: 'numeric', month: '2-digit', day: '2-digit', timeZone: 'Europe/London' });
        fetch("https://a.klaviyo.com/client/subscriptions/?company_id=TcT7Zq", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Revision": "2023-12-15",
          },
          body: JSON.stringify(bodyData),
        })
        .then(response => {
          if(klaviyoContainer.querySelector('.klaviyo-newsletter--success')) {
            klaviyoContainer.querySelector('.klaviyo-newsletter--success').style.display = "block";
          }
        })
        .catch((error) => {
          if(klaviyoContainer.querySelector('.klaviyo-newsletter--error')) {
            klaviyoContainer.querySelector('.klaviyo-newsletter--error').style.display = "block";
          }
        });
      });
    }
  }
});

/* --- Cart Upsell --- */
var CartUpsell = class extends HTMLElement {
  constructor() {
    super();

    this.dynamicProduct = this.getAttribute('data-preload') || null;

    if (this.dynamicProduct) {
      this.init();
    }
  }

  async init() {
    const recommendations = 
      await fetch(`${ window.Shopify.routes.root }recommendations/products?product_id=${ this.dynamicProduct }&section_id=cart-upsell&limit=2`)
      .then(response => response.text())
      .then(data => {
        return data;
      });

      const html = new DOMParser().parseFromString(recommendations, 'text/html');
      this.innerHTML = html.querySelector('[data-dynamic-content]').innerHTML;

      this.removeAttribute('data-preload');
      this.classList.remove('hidden');
  }
}

window.customElements.define('cart-upsell', CartUpsell);